import { Routes, Route, Navigate } from "react-router";
import { AppLayout } from "../components/layout/AppLayout";
import { Dashboard } from "../pages/dashboard/Dashboard";

import { TradingStrategiesCoreui as TradingStrategies } from "../pages/trading-strategies/TradingStrategies";
import { TradingStrategyDetailsCoreui as TradingStrategyDetails } from "../pages/trading-strategies/TradingStrategyDetails";
import { CartCoreui as Cart } from "../pages/trading-strategies/Cart";
import { RequestStrategyWizardCoreui as RequestStrategyWizard } from "../pages/trading-strategies/RequestStrategyWizard/RequestStrategyWizard";
import { CheckoutWizardCoreui as CheckoutWizard } from "../pages/trading-strategies/CheckoutWizard/CheckoutWizard";
import { MySubscriptionsCoreui as MySubscriptions } from "../pages/trading-strategies/MySubscriptions";
import { SubscriptionDetailCoreui as SubscriptionDetail } from "../pages/trading-strategies/SubscriptionDetail";
import { SubscriptionEndWizardCoreui as SubscriptionEndWizard } from "../pages/trading-strategies/SubscriptionEndWizard/SubscriptionEndWizard";
import { SubscriptionResumeWizardCoreui as SubscriptionResumeWizard } from "../pages/trading-strategies/SubscriptionResumeWizard/SubscriptionResumeWizard";
import { SubscriptionStayMonthlyWizardCoreui as SubscriptionStayMonthlyWizard } from "../pages/trading-strategies/SubscriptionStayMonthlyWizard/SubscriptionStayMonthlyWizard";

import { BillingLandingCoreui as BillingLanding } from "../pages/billing/BillingLanding";
import { ProfileLandingCoreui as ProfileLanding } from "../pages/profile/ProfileLanding";
import { ProfileEditWizardCoreui as ProfileEditWizard } from "../pages/profile/ProfileEditWizard";
import { EmailChangeWizardCoreui as EmailChangeWizard } from "../pages/profile/EmailChangeWizard";
import { ChangePasswordCoreui as ChangePassword } from "../pages/profile/ChangePassword";
import CommunicationPreferencesWizard from "../pages/profile/CommunicationPreferencesWizard";
import { TradingViewUsernameWizard } from "../pages/profile/TradingViewUsernameWizard";

import { SignalManagementPreview } from "../pages/signal-management/SignalManagementPreview";
import { Signals } from "../pages/signals/Signals";
import { SignalDetail } from "../pages/signals/SignalDetail";
import { ConfigureSignals } from "../pages/signals/ConfigureSignals";
import { ConfigureSignalsWizard } from "../pages/signals/ConfigureSignalsWizard";
import { BrowseMemberships } from "../pages/memberships/BrowseMemberships";
import { RequestMembershipWizard } from "../pages/memberships/RequestMembershipWizard";
import { MembershipDetails } from "../pages/memberships/MembershipDetails";
import { MembershipEndWizard } from "../pages/memberships/MembershipEndWizard";
import { MembershipResumeWizard } from "../pages/memberships/MembershipResumeWizard";
import { BrowseAddOns } from "../pages/add-ons/BrowseAddOns";
import { AddOnDetails } from "../pages/add-ons/AddOnDetails";
import { AddOnEndWizard } from "../pages/add-ons/AddOnEndWizard";
import { AddOnResumeWizard } from "../pages/add-ons/AddOnResumeWizard";
import { PortfolioBuilder } from "../pages/portfolio-builder/PortfolioBuilder";
import { PortfolioTracker } from "../pages/portfolio-tracker/PortfolioTracker";
import { PortfolioTrackerStrategy } from "../pages/portfolio-tracker/PortfolioTrackerStrategy";

import { Offers } from "../pages/offers/Offers";
import { PartnerOffers } from "../pages/partner-offers/PartnerOffers";
import { HelpIndex } from "../pages/help/HelpIndex";
import { HelpArticle } from "../pages/help/HelpArticle";

import { LegalPage } from "../pages/legal/LegalPage";
import { Contact } from "../pages/info/Contact";
import { Notices } from "../pages/info/Notices";

import { NotFound } from "../pages/NotFound";

import { RequireMemberships } from "./RequireMemberships";
import { RequirePortfolioBuilder } from "./RequirePortfolioBuilder";
import { RequirePortfolioTracker } from "./RequirePortfolioTracker";
import {
  routePaths,
  helpArticlePath,
  retiredHelpArticleSlugs,
} from "./route-paths";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path={routePaths.dashboard} element={<Dashboard />} />

        <Route
          path={routePaths.strategies}
          element={<TradingStrategies />}
        />
        <Route
          path={routePaths.requestStrategy}
          element={<RequestStrategyWizard />}
        />
        <Route
          path={routePaths.strategyDetails}
          element={<TradingStrategyDetails />}
        />
        <Route path={routePaths.cart} element={<Cart />} />
        <Route path={routePaths.checkout} element={<CheckoutWizard />} />
        <Route path={routePaths.myStrategies} element={<MySubscriptions />} />
        <Route element={<RequireMemberships />}>
          <Route path={routePaths.memberships} element={<BrowseMemberships />} />
          <Route path={routePaths.requestMembership} element={<RequestMembershipWizard />} />
          <Route path={routePaths.membershipDetails} element={<MembershipDetails />} />
          <Route path={routePaths.membershipEnd} element={<MembershipEndWizard />} />
          <Route path={routePaths.membershipResume} element={<MembershipResumeWizard />} />
        </Route>
        <Route path={routePaths.addOns} element={<BrowseAddOns />} />
        <Route path={routePaths.addOnDetails} element={<AddOnDetails />} />
        <Route path={routePaths.addOnEnd} element={<AddOnEndWizard />} />
        <Route path={routePaths.addOnResume} element={<AddOnResumeWizard />} />
        <Route element={<RequirePortfolioBuilder />}>
          <Route path={routePaths.portfolioBuilder} element={<PortfolioBuilder />} />
        </Route>
        <Route
          path={routePaths.myStrategyDetails}
          element={<TradingStrategyDetails />}
        />
        <Route
          path={routePaths.subscriptionEnd}
          element={<SubscriptionEndWizard />}
        />
        <Route
          path={routePaths.subscriptionResume}
          element={<SubscriptionResumeWizard />}
        />
        <Route
          path={routePaths.subscriptionStayMonthly}
          element={<SubscriptionStayMonthlyWizard />}
        />
        <Route
          path={routePaths.subscriptionDetail}
          element={<SubscriptionDetail />}
        />

        <Route path={routePaths.billing} element={<BillingLanding />} />
        <Route path={routePaths.profile} element={<ProfileLanding />} />
        <Route path={routePaths.profileEdit} element={<ProfileEditWizard />} />
        <Route path={routePaths.profileEmail} element={<EmailChangeWizard />} />
        <Route path={routePaths.profilePassword} element={<ChangePassword />} />
        <Route
          path={routePaths.profileCommunications}
          element={<CommunicationPreferencesWizard />}
        />
        <Route path={routePaths.profileTradingView} element={<TradingViewUsernameWizard />} />

        <Route path={routePaths.signals} element={<Signals />} />
        <Route path={routePaths.signalsConfigure} element={<ConfigureSignals />} />
        <Route path={routePaths.signalsConfigureChange} element={<ConfigureSignalsWizard />} />
        <Route element={<RequirePortfolioTracker />}>
          <Route path={routePaths.portfolioTracker} element={<PortfolioTracker />} />
          <Route path={routePaths.portfolioTrackerStrategy} element={<PortfolioTrackerStrategy />} />
        </Route>
        <Route path={routePaths.signalDetail} element={<SignalDetail />} />

        <Route
          path={routePaths.signalManagementPreview}
          element={<SignalManagementPreview />}
        />

        <Route path={routePaths.offers} element={<Offers />} />
        <Route path={routePaths.partnerOffers} element={<PartnerOffers />} />

        <Route path={routePaths.help} element={<HelpIndex />} />
        <Route path={routePaths.helpArticle} element={<HelpArticle />} />

        {/* "How it works" is a help article now. The old path stays alive as a
            redirect rather than a 404 — it was linked from the portal footer
            and may be bookmarked. */}
        <Route
          path={routePaths.howItWorks}
          element={<Navigate to={helpArticlePath("how-it-works")} replace />}
        />
        {retiredHelpArticleSlugs.map((slug) => (
          <Route
            key={slug}
            path={helpArticlePath(slug)}
            element={<Navigate to={helpArticlePath("how-it-works")} replace />}
          />
        ))}

        <Route path={routePaths.terms} element={<LegalPage slug="terms" />} />
        <Route path={routePaths.privacy} element={<LegalPage slug="privacy" />} />
        <Route
          path={routePaths.disclosures}
          element={<LegalPage slug="disclosures" />}
        />
        <Route path={routePaths.contact} element={<Contact />} />
        <Route path={routePaths.notices} element={<Notices />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
